import styled from '@emotion/styled';
import { BreakpointValue } from 'consts/breakpoints';


export const rangeToGalleryHeight: Record<BreakpointValue, number> = {
  1: 233,
  2: 393,
  3: 393,
  4: 520,
  5: 520,
};

export const SliderItemContainer = styled.div<{}>`
  ${({ theme }) => Object.keys(rangeToGalleryHeight).map(key => (
    theme.media.showAt({ at: (+key as BreakpointValue) })`
      height: ${rangeToGalleryHeight[key]}px;
    `
  ))};
  position: relative;
  flex-grow: 1;
  & > div {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-repeat: no-repeat;
    background-position: center;
    background-color: ${props => props.theme.colors.neutrals.white};
    transform-origin: top left;
    background-size: cover;
  }
`;

export const GalleryWrapper = styled.div`
  position: relative;
  width: 100%;
  direction: ltr;
`;
